import { Component, HostListener, OnInit } from '@angular/core';
import AOS from 'aos';  // Asegúrate de importar AOS

@Component({
  selector: 'app-premios',
  templateUrl: './premios.component.html',
  styleUrls: ['./premios.component.scss']
})
export class PremiosComponent implements OnInit {
  isSmallScreen: boolean;

  premios = [
    {
      id: 'carSlider1',
      title: 'DEPARTAMENTO',
      subtitle: 'AMUEBLADO',
      place: 'BOSQUE REAL FIVE',
      subplace: 'EDO. MÉXICO',
      price: 'VALOR + DE 12 MILLONES',
      imagenes: [
        '/assets/img/sorteo2025/casas/casa1.jpg',
        '/assets/img/sorteo2025/casas/casa1.jpg'
      ],
      number: '1° Premio'
    },
    {
      id: 'carSlider2',
      title: 'DEPARTAMENTO',
      subtitle: 'AMUEBLADO',
      place: 'BREZZA TOWERS MAR',
      subplace: 'CANCÚN',
      price: 'VALOR + DE 12 MILLONES',
      imagenes: [
        '/assets/img/sorteo2025/casas/casa2.jpg',
        '/assets/img/sorteo2025/casas/casa2.jpg'
      ],
      number: '2° Premio'
    },
    {
      id: 'carSlider3',
      title: 'CASA',
      subtitle: 'AMUEBLADA',
      place: 'EL ORIGEN ',
      subplace: 'MÉRIDA',
      price: 'VALOR + DE 8 MILLONES',
      imagenes: [
        '/assets/img/sorteo2025/casas/casa3.jpg',
        '/assets/img/sorteo2025/casas/casa3.jpg'
      ],
      number: '3° Premio'
    },
    {
      id: 'carSlider4',
      title: 'CASA',
      subtitle: 'AMUEBLADA',
      place: 'ZIBATÁ',
      subplace: 'QUERÉTARO',
      price: 'VALOR + DE 5 MILLONES',
      imagenes: [
        '/assets/img/sorteo2025/casas/casa4.jpg',
        '/assets/img/sorteo2025/casas/casa4.jpg'
      ],
      number: '4° Premio'
    },
    {
      id: 'carSlider5',
      title: 'CASA', 
      subtitle:'AMUEBLADA', 
      place: 'EL CAPRICHO', 
      subplace:'PUEBLA', 
      price: 'VALOR + DE 5 MILLONES', 
      imagenes: [
        '/assets/img/sorteo2025/casas/casa5.jpg',
        '/assets/img/sorteo2025/casas/casa5.jpg'
      ],
      number: '5° Premio'
    },
  ];
  constructor() { }

  ngOnInit(): void {
    this.isSmallScreen = window.innerWidth <= 767;
    window.addEventListener('resize', this.onResize.bind(this));
    // setTimeout(() => {
    //   document.querySelector(".byd").classList.add("animate-bounce");
    //   document.querySelector(".bmw").classList.add("animate-bounce2");
    // }, 2400);

    AOS.init({
      once: true,  // Para que las animaciones se activen solo una vez
      startEvent: 'load',  // Asegura que las animaciones inicien al cargar la página
    });

    // Fuerza la actualización de AOS para que se apliquen las animaciones de inmediato
    AOS.refresh();
  }


  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.isSmallScreen = window.innerWidth <= 767;
  }
}
